import React from 'react'
const ItemSelectIcon = () => (
  <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.00049 4.08579L0.586275 5.5L5.65712 10.5711L7.07133 10.5711L7.07133 9.15685L2.00049 4.08579Z"
      fill="#DA291C"
    />
    <path
      d="M18.0548 1.41421L16.6406 0L7.48395 9.15685L7.48395 10.5711L8.89817 10.5711L18.0548 1.41421Z"
      fill="#DA291C"
    />
  </svg>
)
export default ItemSelectIcon
